// 已有封装的组件previewFile统一管理样式和方法，此文件为部分页面依赖
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
export default {
    data() {
        return {
            previewShow: false,
            previewUrl: [],
            previewIndex: 0
        }
    },
    components: {
        ElImageViewer
    },
    methods: {
        onPreviewImg(url, index) {
            this.previewUrl = url;
            this.previewIndex = index;
            this.previewShow = true;
        },
        closeViewer() {
            this.previewShow = false;
        }
    }
}